import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitialContactDialogComponent } from './initial-contact-dialog/initial-contact-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material.module';
import { MyContactsLayoutComponent } from './my-contacts-layout/my-contacts-layout.component';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactConversationComponent } from './my-contacts-layout/contact-conversation/contact-conversation.component';
import { NoContactConversationsComponent } from './my-contacts-layout/no-contact-conversations/no-contact-conversations.component';
// tslint:disable-next-line: max-line-length
import { ContactConversationMessageComponent } from './my-contacts-layout/contact-conversation/contact-conversation-message/contact-conversation-message.component';
import { ConversationPreviewComponent } from './my-contacts-layout/conversation-preview/conversation-preview.component';
import { MyServiceContactsComponent } from './my-service-contacts/my-service-contacts.component';
import { ServiceContactListingComponent } from './my-service-contacts/service-contact-listing/service-contact-listing.component';
// tslint:disable-next-line: max-line-length
import { ServiceContactConversationPreviewComponent } from './my-service-contacts/service-contact-conversation-preview/service-contact-conversation-preview.component';

@NgModule({
  declarations: [
    InitialContactDialogComponent,
    MyContactsLayoutComponent,
    ContactConversationComponent,
    NoContactConversationsComponent,
    ContactConversationMessageComponent,
    ConversationPreviewComponent,
    MyServiceContactsComponent,
    ServiceContactListingComponent,
    ServiceContactConversationPreviewComponent
  ],
  imports: [CommonModule, SharedModule, MaterialModule, ContactRoutingModule],
  entryComponents: [InitialContactDialogComponent]
})
export class ContactModule {}
